/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import produce from 'immer';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const createPageSlice = (set) => ({
  isOrderBeingCreated: false,
  isOrderBeingCreatedDirectly: true, // We set initial value as true to avoid a loading screen blink (between loading page configs and started order direct creation)
  setOrderBeingCreated: (value) => {
    set(
      produce((draft) => {
        draft.isOrderBeingCreated = value;
      }),
    );
  },
  setOrderBeingCreatedDirectly: (value) => {
    set(
      produce((draft) => {
        draft.isOrderBeingCreatedDirectly = value;
      }),
    );
  },
});

const createVtexItemsSlice = (set) => ({
  vtexOrderItems: [],
  validVtexOrderItems: [],
  selectedVtexItem: 0,
  setSelectedVtexItem: (index) => {
    set(
      produce((draft) => {
        draft.selectedVtexItem = index;
      }),
    );
  },
  setValidVtexOrderItems: (items) => {
    set(
      produce((draft) => {
        draft.validVtexOrderItems = items;
      }),
    );
  },
  setVtexOrderItems: (items) => {
    set(
      produce((draft) => {
        draft.vtexOrderItems = items.map(({ __typename, ...item }) => ({
          ...item,
          selectedQuantity: 0,
        }));
      }),
    );
  },
  setVtexItemQuantity: (vtexOrderItemId, quantity) => {
    set(
      produce((draft) => {
        const vtexOrderItem = draft.vtexOrderItems.find(
          (item) => item.uniqueId === vtexOrderItemId,
        );
        if (vtexOrderItem) {
          vtexOrderItem.selectedQuantity = quantity;
        }
      }),
    );
  },
  setValidVtexOrderItemReason: (reason) => {
    set(
      produce((draft) => {
        draft.validVtexOrderItems[draft.selectedVtexItem].reason = reason;
      }),
    );
  },
  setValidVtexOrderItemResolution: (resolution) => {
    set(
      produce((draft) => {
        draft.validVtexOrderItems[draft.selectedVtexItem].resolution =
          resolution;
      }),
    );
  },
});

const createInitialFormSlice = (set) => ({
  formData: null,
  showClientCreationForm: false,
  setFormData: (data) => {
    set(
      produce((draft) => {
        draft.formData = data;
      }),
    );
  },
  setShowClientCreationForm: (value) => {
    set(
      produce((draft) => {
        draft.showClientCreationForm = value;
      }),
    );
  },
});

const createManualItemsSlice = (set) => ({
  manualOrderItems: [
    {
      itemName: '',
      quantity: '',
      price: '',
      category: '',
      reason: '',
      resolution: '',
    },
  ],
  selectedManualItem: 0,
  setCurrentManualItem: (index, item) => {
    set(
      produce((draft) => {
        draft.manualOrderItems[index] = item;
      }),
    );
  },
  addManualItem: (item) => {
    set(
      produce((draft) => {
        draft.manualOrderItems.push(item);
      }),
    );
  },
  removeManualItem: (index) => {
    set(
      produce((draft) => {
        draft.manualOrderItems = draft.manualOrderItems.filter(
          (_, i) => i !== index,
        );
      }),
    );
  },
  setNextSelectedManualItem: () => {
    set(
      produce((draft) => {
        draft.selectedManualItem += 1;
      }),
    );
  },
  setPreviousSelectedManualItem: () => {
    set(
      produce((draft) => {
        draft.selectedManualItem -= 1;
      }),
    );
  },
});

const createMemphisOrderSlice = (set) => ({
  memphisOrderInfo: null,
  setMemphisOrderInfo: (data) => {
    set(
      produce((draft) => {
        draft.memphisOrderInfo = data;
      }),
    );
  },
});

const usePageStore = create(
  devtools(
    (...a) => ({
      ...createPageSlice(...a),
      ...createInitialFormSlice(...a),
      ...createManualItemsSlice(...a),
      ...createVtexItemsSlice(...a),
      ...createMemphisOrderSlice(...a),
    }),
    { name: 'PublicOrderCreationPageStore' },
  ),
);

export default usePageStore;
